import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  isTestModeActive,
  enableTestMode,
  disableTestMode,
  remainingLabel,
} from "@/lib/testMode";

export function TestModeToggle() {
  const [, setTick] = useState(0); // re-render every second for the countdown
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  const active = isTestModeActive();
  const remaining = remainingLabel();

  const toggle = () => {
    if (active) {
      disableTestMode();
      toast.success("TEST MODE OFF · real prices restored on this browser");
    } else {
      enableTestMode();
      toast.success("TEST MODE ON · only this browser sees $2/$3 · auto-off in 10 min");
    }
    setTick((t) => t + 1);
  };

  return (
    <button
      data-testid="admin-test-mode-toggle"
      onClick={toggle}
      title={
        active
          ? `Test mode is ON on this browser. Auto-off in ${remaining}.`
          : "Test mode is OFF. Click to turn ON for 10 minutes (this browser only)."
      }
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-body font-semibold border transition-colors ${
        active
          ? "bg-amber-400 text-cvc-navy border-amber-300 hover:bg-amber-300"
          : "bg-transparent text-cvc-cream/70 border-cvc-cream/30 hover:bg-cvc-cream/10"
      }`}
    >
      <span
        className={`inline-block w-2 h-2 rounded-full ${active ? "bg-cvc-navy animate-pulse" : "bg-cvc-cream/40"}`}
      />
      {active ? `TEST MODE · ${remaining}` : "Test mode OFF"}
    </button>
  );
}
